(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["er-art-science"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';
  if (window.erFloatingCoffeeController) {
    window.erFloatingCoffeeController.initialize(document);
    return;
  }
  var instances = new Map();
  var selector = '[data-er-floating-coffees]';
  function initialize(root) {
    var carousels = [];
    if (root.matches && root.matches(selector)) carousels.push(root);
    if (root.querySelectorAll) carousels = carousels.concat(Array.from(root.querySelectorAll(selector)));
    carousels.forEach(function (carousel) {
      if (instances.has(carousel) || carousel.dataset.erFloatingReady !== 'true') return;
      var track = carousel.querySelector('[data-er-floating-track]');
      var cards = Array.from(track.querySelectorAll('[data-er-floating-card]'));
      if (cards.length < 2) return;
      var controls = carousel.querySelector('[data-er-floating-controls]');
      var dotsContainer = carousel.querySelector('[data-er-floating-dots]');
      var play = carousel.querySelector('[data-er-floating-play]');
      var playText = carousel.querySelector('[data-er-floating-play-text]');
      var playIcon = carousel.querySelector('[data-er-floating-play-icon]');
      var status = carousel.querySelector('[data-er-floating-status]');
      var media = window.matchMedia('(prefers-reduced-motion: reduce)');
      var abort = new AbortController();
      var index = 0;
      var orbitPosition = 0;
      var timer = null;
      var paused = false;
      var hovering = false;
      var inView = !('IntersectionObserver' in window);
      var dragging = null;
      var suppressClickUntil = 0;
      var playPointerPaused = null;
      var originalTabs = new Map();
      var names = cards.map(function (card) { return card.dataset.erCoffeeName || 'Coffee'; });
      function listen(target, type, handler, options) {
        target.addEventListener(type, handler, Object.assign({}, options || {}, { signal: abort.signal }));
      }
      function clearTimer() { window.clearTimeout(timer); timer = null; }
      function schedule() {
        clearTimer();
        if (!paused && !media.matches && !hovering && inView && !document.hidden && carousel.isConnected) {
          timer = window.setTimeout(function () { show(index + 1, false); }, 2000);
        }
      }
      function updatePlay() {
        play.disabled = media.matches;
        playText.textContent = media.matches ? 'Motion off' : paused ? 'Play' : 'Pause';
        playIcon.textContent = media.matches || paused ? '▶' : 'Ⅱ';
        play.setAttribute('aria-label', media.matches ? 'Automatic rotation disabled for reduced motion' : paused ? 'Start automatic rotation' : 'Pause automatic rotation');
      }
      function pause() { paused = true; clearTimer(); updatePlay(); }
      function show(nextIndex, announce) {
        var next = ((nextIndex % cards.length) + cards.length) % cards.length;
        // Never strand keyboard focus inside a card we are about to conceal.
        if (next !== index && cards[index].contains(document.activeElement)) carousel.focus({ preventScroll: true });
        var distance = next - index;
        if (distance > cards.length / 2) distance -= cards.length;
        if (distance < -cards.length / 2) distance += cards.length;
        if (cards.length === 2 && Math.abs(distance) === 1) distance = nextIndex > index ? 1 : -1;
        orbitPosition += distance;
        index = next;
        // Four coffees use a real circular orbit. Two arrivals retain two genuine bags,
        // spaced 120 degrees apart, so the rear bag stays recognizable rather than hidden.
        var phase = cards.length === 2 ? Math.floor(orbitPosition / 2) * 360 + (((orbitPosition % 2) + 2) % 2) * 120 : orbitPosition * (360 / cards.length);
        cards.forEach(function (card, i) {
          var active = i === index;
          card.classList.toggle('is-current', active);
          card.classList.toggle('is-next', i === (index + 1) % cards.length);
          card.classList.toggle('is-previous', cards.length > 2 && i === (index - 1 + cards.length) % cards.length);
          var visual = card.querySelector('[data-er-floating-visual]');
          visual.style.setProperty('--er-orbit-angle', ((cards.length === 2 ? i * 120 : i * (360 / cards.length)) - phase) + 'deg');
          card.setAttribute('aria-hidden', active ? 'false' : 'true');
          card.inert = !active;
          // Fallback for browsers without inert, and defense against concealed links in the tab order.
          card.querySelectorAll('a,button,input,select,textarea,[tabindex]').forEach(function (element) {
            if (!originalTabs.has(element)) originalTabs.set(element, element.getAttribute('tabindex'));
            var original = originalTabs.get(element);
            if (!active) element.setAttribute('tabindex', '-1');
            else if (original === null) element.removeAttribute('tabindex');
            else element.setAttribute('tabindex', original);
          });
          dots[i].setAttribute('aria-current', active ? 'true' : 'false');
        });
        if (announce) status.textContent = names[index] + ', slide ' + (index + 1) + ' of ' + cards.length;
        schedule();
      }
      dotsContainer.textContent = '';
      var dots = cards.map(function (card, i) {
        card.setAttribute('role', 'group');
        card.setAttribute('aria-roledescription', 'slide');
        card.setAttribute('aria-label', names[i] + ', ' + (i + 1) + ' of ' + cards.length);
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'er-floating-dot';
        dot.setAttribute('aria-label', 'Show ' + names[i] + ', slide ' + (i + 1) + ' of ' + cards.length);
        listen(dot, 'click', function () { pause(); show(i, true); });
        dotsContainer.appendChild(dot);
        return dot;
      });
      carousel.setAttribute('role', 'region');
      carousel.setAttribute('aria-roledescription', 'carousel');
      carousel.setAttribute('tabindex', '0');
      track.setAttribute('aria-live', 'off');
      carousel.classList.add('is-enhanced');
      controls.hidden = false;
      listen(carousel.querySelector('[data-er-floating-prev]'), 'click', function () { pause(); show(index - 1, true); });
      listen(carousel.querySelector('[data-er-floating-next]'), 'click', function () { pause(); show(index + 1, true); });
      listen(play, 'click', function () {
        if (media.matches) return;
        // Focus pauses first; retain the intent from pointerdown so clicking Pause never starts it.
        paused = playPointerPaused === null ? !paused : !playPointerPaused;
        playPointerPaused = null; updatePlay(); schedule();
      });
      listen(carousel, 'pointerenter', function (event) { if (event.pointerType === 'mouse') { hovering = true; clearTimer(); } });
      listen(carousel, 'pointerleave', function (event) { if (event.pointerType === 'mouse') { hovering = false; schedule(); } });
      listen(play, 'blur', function () { playPointerPaused = null; });
      listen(document, 'pointerup', function (event) {
        // An interrupted press outside this control must not affect a later keyboard activation.
        if (!play.contains(event.target)) playPointerPaused = null;
      });
      listen(carousel, 'focusin', pause);
      listen(carousel, 'keydown', function (event) {
        if (event.altKey || event.ctrlKey || event.metaKey || event.shiftKey) return;
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight' || event.key === 'Home' || event.key === 'End') {
          event.preventDefault();
          pause();
          show(event.key === 'Home' ? 0 : event.key === 'End' ? cards.length - 1 : index + (event.key === 'ArrowRight' ? 1 : -1), true);
        }
      });
      listen(carousel, 'pointerdown', function (event) {
        if (event.target.closest('[data-er-floating-play]')) playPointerPaused = paused;
        else pause();
        if (track.contains(event.target) && event.isPrimary && (event.pointerType === 'touch' || event.pointerType === 'pen')) {
          dragging = { id: event.pointerId, x: event.clientX, y: event.clientY };
        }
      }, { passive: true });
      listen(carousel, 'pointerup', function (event) {
        if (!dragging || event.pointerId !== dragging.id) return;
        var dx = event.clientX - dragging.x;
        var dy = event.clientY - dragging.y;
        dragging = null;
        if (Math.abs(dx) > 35 && Math.abs(dx) > Math.abs(dy) * 1.25) {
          suppressClickUntil = Date.now() + 600;
          show(index + (dx < 0 ? 1 : -1), true);
        }
      }, { passive: true });
      listen(carousel, 'pointercancel', function () { dragging = null; playPointerPaused = null; });
      listen(track, 'click', function (event) {
        var card = event.target.closest('[data-er-floating-card]');
        if (Date.now() < suppressClickUntil || (card && card !== cards[index])) {
          event.preventDefault(); event.stopPropagation();
        }
      }, { capture: true });
      listen(document, 'visibilitychange', schedule);
      listen(media, 'change', function () { updatePlay(); schedule(); });
      var observer = null;
      if ('IntersectionObserver' in window) {
        observer = new IntersectionObserver(function (entries) { inView = entries[0].isIntersecting; schedule(); }, { threshold: 0.25 });
        observer.observe(carousel);
      }
      instances.set(carousel, {
        selectBlock: function (blockId) {
          var selected = cards.findIndex(function (card) { return card.dataset.erBlockId === blockId; });
          if (selected !== -1) { pause(); show(selected, false); }
        },
        destroy: function () {
          clearTimer(); abort.abort(); if (observer) observer.disconnect();
          originalTabs.forEach(function (original, element) { if (original === null) element.removeAttribute('tabindex'); else element.setAttribute('tabindex', original); });
          cards.forEach(function (card) { card.inert = false; card.classList.remove('is-current', 'is-next', 'is-previous'); card.querySelector('[data-er-floating-visual]').style.removeProperty('--er-orbit-angle'); ['role','aria-roledescription','aria-label','aria-hidden'].forEach(function (attribute) { card.removeAttribute(attribute); }); });
          carousel.classList.remove('is-enhanced');
          ['role','aria-roledescription','tabindex'].forEach(function (attribute) { carousel.removeAttribute(attribute); });
          track.removeAttribute('aria-live'); controls.hidden = true;
          dotsContainer.textContent = ''; status.textContent = '';
          instances.delete(carousel);
        }
      });
      updatePlay(); show(0, false);
    });
  }
  document.addEventListener('shopify:section:load', function (event) { initialize(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    instances.forEach(function (instance, carousel) { if (event.target === carousel || event.target.contains(carousel)) instance.destroy(); });
  });
  document.addEventListener('shopify:block:select', function (event) {
    instances.forEach(function (instance, carousel) { if (carousel.contains(event.target)) instance.selectBlock(event.detail.blockId); });
  });
  window.erFloatingCoffeeController = { initialize: initialize };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initialize(document); }, { once: true });
  else initialize(document);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["er-film-story"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('er-film-story')) {
    customElements.define('er-film-story', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.teaser = this.querySelector('.er-film__teaser');
        this.full = this.querySelector('.er-film__full');
        this.dialog = this.querySelector('dialog');
        this.slides = Array.from(this.querySelectorAll('[data-slide]'));
        this.reasons = this.querySelector('.er-film__reasons');
        this.motion = this.querySelector('[data-motion-toggle]');
        this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
        this.index = 0;
        this.inView = false;
        this.paused = this.dataset.autoplay !== 'true' || this.reduced.matches || Boolean(navigator.connection?.saveData);
        this.hovered = false;
        this.focused = false;
        this.interval = Math.max(4, Number(this.dataset.interval) || 5) * 1000;
        this.observer = new IntersectionObserver(entries => {
          this.inView = entries[0].isIntersecting;
          this.sync();
        }, { threshold: 0.15 });
        this.observer.observe(this);
        this.motion.addEventListener('click', () => { this.paused = !this.paused; this.sync(); }, { signal });
        this.querySelector('[data-prev]').addEventListener('click', () => this.show(this.index - 1, true), { signal });
        this.querySelector('[data-next]').addEventListener('click', () => this.show(this.index + 1, true), { signal });
        this.reasons.addEventListener('mouseenter', () => { this.hovered = true; this.sync(); }, { signal });
        this.reasons.addEventListener('mouseleave', () => { this.hovered = false; this.sync(); }, { signal });
        this.reasons.addEventListener('focusin', () => { this.focused = true; this.sync(); }, { signal });
        this.reasons.addEventListener('focusout', event => { this.focused = this.reasons.contains(event.relatedTarget); this.sync(); }, { signal });
        document.addEventListener('visibilitychange', () => this.sync(), { signal });
        document.addEventListener('er:video-modal-change', () => this.sync(), { signal });
        this.reduced.addEventListener('change', () => { if (this.reduced.matches) this.paused = true; this.sync(); }, { signal });
        this.querySelector('[data-film-open]').addEventListener('click', event => {
          if (!this.dialog.showModal) return;
          event.preventDefault();
          document.querySelectorAll('video').forEach(video => { if (video !== this.full) video.pause(); });
          this.dialog.showModal();
          document.dispatchEvent(new Event('er:video-modal-change'));
          this.sync();
          if (!this.full.getAttribute('src')) this.full.src = this.full.dataset.src;
          this.full.muted = false;
          this.full.currentTime = 0;
          const playback = this.full.play();
          if (playback) playback.catch(() => this.full.focus());
        }, { signal });
        this.querySelector('[data-film-close]').addEventListener('click', () => this.dialog.close(), { signal });
        this.dialog.addEventListener('click', event => {
          if (event.target !== this.dialog) return;
          const bounds = this.dialog.getBoundingClientRect();
          if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) this.dialog.close();
        }, { signal });
        this.dialog.addEventListener('close', () => {
          this.full.pause();
          document.dispatchEvent(new Event('er:video-modal-change'));
          this.sync();
          this.querySelector('[data-film-open]').focus({ preventScroll: true });
        }, { signal });
        this.sync();
      }
      show(index, announce = false) {
        this.index = (index + this.slides.length) % this.slides.length;
        this.slides.forEach((slide, i) => {
          slide.hidden = i !== this.index;
          slide.classList.toggle('is-active', i === this.index);
        });
        this.querySelector('[data-slide-count]').textContent = String(this.index + 1).padStart(2, '0');
        this.querySelector('[data-progress]').style.width = `${((this.index + 1) / this.slides.length) * 100}%`;
        if (announce) this.querySelector('[data-announcement]').textContent = this.slides[this.index].textContent.trim();
        this.sync();
      }
      sync() {
        clearTimeout(this.timer);
        const running = this.inView && !this.paused && !document.hidden && !document.querySelector('.er-motion__dialog[open], .er-film__dialog[open]');
        this.motion.setAttribute('aria-pressed', String(this.paused));
        this.querySelector('[data-pause-label]').hidden = this.paused;
        this.querySelector('[data-resume-label]').hidden = !this.paused;
        this.motion.setAttribute('aria-label', this.querySelector(this.paused ? '[data-resume-label]' : '[data-pause-label]').textContent);
        if (running && this.teaser.dataset.src) {
          this.teaser.muted = true;
          if (!this.teaser.getAttribute('src')) this.teaser.src = this.teaser.dataset.src;
          const playback = this.teaser.play();
          if (playback) playback.catch(() => {});
        } else this.teaser.pause();
        if (running && !this.hovered && !this.focused) this.timer = setTimeout(() => this.show(this.index + 1), this.interval);
      }
      disconnectedCallback() {
        clearTimeout(this.timer);
        this.teaser?.pause();
        this.full?.pause();
        this.observer?.disconnect();
        this.controller?.abort();
        this.controller = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["er-rooted-story"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('play', (event) => {
    if (event.target.matches('.er-story-video')) event.target.setAttribute('data-playing', '');
  }, true);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["er-savings-banner"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',function(event){const button=event.target.closest('.er-slim-pause');if(!button)return;const banner=button.closest('[data-er-scrolling-offer]');const paused=banner.classList.toggle('is-paused');button.setAttribute('aria-pressed',String(paused));button.setAttribute('aria-label',paused?button.dataset.resumeLabel:button.dataset.pauseLabel);button.firstElementChild.textContent=paused?'▶':'Ⅱ';});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
